import humps from "humps"

function buildJsonFetchOptions(method, data) {
  const options = buildGeneralOptions(method)
  options.headers["Content-Type"] = "application/json"
  options.body = JSON.stringify(humps.decamelizeKeys(data))
  return options
}

function buildGeneralOptions(method) {
  const headers = {}
  const csrfContainer = document.querySelector("meta[name='csrf-token']")
  if (csrfContainer) headers["X-CSRF-Token"] = csrfContainer.content
  if (window.App.currentLocationId) headers["Plei-Location-Id"] = window.App.currentLocationId
  return {method, credentials: "same-origin", headers}
}

export function postForm(url, formData) {
  const options = buildGeneralOptions("POST")
  options.body = formData
  return fetch(url, options)
}

export function patchForm(url, formData) {
  const options = buildGeneralOptions("PATCH")
  options.body = formData
  return fetch(url, options)
}

export function ajaxGet(url) {
  return fetch(url, buildJsonFetchOptions("GET"))
}

export function ajaxPost(url, data) {
  return fetch(url, buildJsonFetchOptions("POST", data))
}

export function ajaxPut(url, data) {
  return fetch(url, buildJsonFetchOptions("PUT", data))
}

export function ajaxPatch(url, data) {
  return fetch(url, buildJsonFetchOptions("PATCH", data))
}

export function ajaxDelete(url) {
  return fetch(url, buildJsonFetchOptions("DELETE"))
}
